import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AccountService } from '../../services/account.service';
import { NotificationService } from '../../services/notification.service';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  selector: 'login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  model: any = {};
  loading: boolean = true;
  psqs: string;
  cryptedId: string;
  id: string;
  check: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private notificationService: NotificationService,
    public configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    // reset login status
    this.accountService.logout();

    this.psqs = this.route.snapshot.queryParams['psqs'];
    this.cryptedId = this.route.snapshot.queryParams['cryptedId'];
    this.id = this.route.snapshot.queryParams['id'];
    this.check = this.route.snapshot.queryParams['check'];

    // Login
    this.login();
  }

  login() {
    this.loading = true;
    this.accountService.login(this.psqs, this.cryptedId, this.id, this.check).subscribe({
      next: data => {
        if (!data) {
          this.notificationService.error('Une erreur est survenue. Veuillez vous réauthentifier.');
          this.loading = false;
        } else if (!data || data.Error) {
          this.notificationService.error(data.Error);
          this.loading = false;
        } else {
          // Suppression des valeurs sauvegardées
          this.accountService.resetLasts();
          this.router.navigate(['/']);
        }
      },
      error: error => {
        this.notificationService.error(error);
        this.loading = false;
      },
    });
  }
}
